import "../styles/posts.css";
// import image from "../../../assets/images/reiki.jpg";
import ContactForm from "../../contact-form/contactForm";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

export default function Prices() {
	const { t } = useTranslation();

	return (
		<div className="singlePost prices-post">
			<div className="singlePostWrapper pricelist-wrapper">
				{/* <img src={image} alt="reiki" className="singlePostImg img-width-auto" /> */}

				<h1 className="singlePostTitle">{t("prices.title")}</h1>

				<Helmet>
					<title>{t("prices.title")}</title>
					<meta name="description" content={t("prices.metaDesc")} />
				</Helmet>

				<div className="singlePostDesc pricelist">
					<ul>
						{t("prices.list", { returnObjects: true }).map((item, index) => (
							<li key={index} className="tick-shaped">
								{item}
							</li>
						))}
					</ul>
				</div>
			</div>

			<div className="contact-form-container">
				<h3>{t("contact.heading")}</h3>
				<ContactForm />
			</div>
		</div>
	);
}
